import dayjs, { Dayjs } from 'dayjs';
import { getBaseDomain } from '@/requestManager';

const nthMonths = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
]

export interface PanoramaInterface {
  id?: number;
  filename?: string;
  pointId?: number;
  shootingTimestamp?: string;
  uploadShootingId?: number;
  uploadTimestamp?: string;
}

export class Panorama implements PanoramaInterface {
  id?: number;
  filename?: string;
  pointId?: number;
  shootingTimestamp?: string;
  uploadShootingId?: number;
  uploadTimestamp?: string;

  constructor(readonly params: any) {
    Object.keys(params).forEach(index => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this[index] = params[index];
    })
  }

  get thumbnail(): string {
    return `${getBaseDomain()}/img/panorama/${this.id}/lq/${this.filename}`;
  }

  get shootingTimestampDayjs(): Dayjs {
    return dayjs(this.shootingTimestamp);
  }

  get shootingDate(): string {
    const day = this.shootingTimestampDayjs.format('D');
    const monthNumber = +this.shootingTimestampDayjs.format('M');

    return `${ day } ${ nthMonths[monthNumber - 1] }`;
  }

  get uploadTimestampDayjs(): Dayjs {
    return dayjs(this.uploadTimestamp);
  }
}
